__turbopack_context__.v({
  "backToLogin": "sso-form-module__pjvHuq__backToLogin",
  "formBody": "sso-form-module__pjvHuq__formBody",
  "formField": "sso-form-module__pjvHuq__formField",
  "formInput": "sso-form-module__pjvHuq__formInput",
  "formInputs": "sso-form-module__pjvHuq__formInputs",
  "formSubtitle": "sso-form-module__pjvHuq__formSubtitle",
  "formTitle": "sso-form-module__pjvHuq__formTitle",
  "formTitleHeading": "sso-form-module__pjvHuq__formTitleHeading",
  "serverError": "sso-form-module__pjvHuq__serverError",
  "ssoBtn": "sso-form-module__pjvHuq__ssoBtn",
  "ssoForm": "sso-form-module__pjvHuq__ssoForm",
});
